import { render } from "./TrainingDocumentListScreen.vue?vue&type=template&id=317dd085"
import script from "./TrainingDocumentListScreen.vue?vue&type=script&lang=ts"
export * from "./TrainingDocumentListScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script